import React from 'react';

export const CSSBiomePoster: React.FC = () => {
  return (
    <div
      className="fixed inset-0 pointer-events-none z-0 overflow-hidden select-none bg-[#F9FAF7]"
      aria-hidden="true"
    >
      {/* Primary Warm Chlorophyll Ambient Glow */}
      <div
        className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] sm:w-[980px] h-[500px] sm:h-[680px] rounded-full opacity-40 blur-[120px] pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at center, rgba(5, 150, 105, 0.18) 0%, rgba(52, 211, 153, 0.10) 45%, transparent 75%)',
        }}
      />

      {/* Secondary Warm Solar Mineral Mist */}
      <div
        className="absolute top-[50%] right-[10%] w-[500px] h-[400px] rounded-full opacity-30 blur-[100px] pointer-events-none"
        style={{
          background: 'radial-gradient(circle, rgba(217, 119, 6, 0.12) 0%, transparent 70%)',
        }}
      />

      {/* Topographic Elevation Contour Map (SVG) */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[650px] sm:w-[900px] h-[650px] sm:h-[900px] opacity-60">
        <svg viewBox="0 0 1000 1000" className="w-full h-full animate-[spin_180s_linear_infinite]">
          {/* Contour Level 01 */}
          <path
            d="M 500 180 C 680 190, 820 320, 810 500 C 800 680, 660 810, 500 800 C 340 790, 200 650, 200 500 C 200 350, 320 170, 500 180 Z"
            fill="none"
            stroke="rgba(10, 28, 20, 0.12)"
            strokeWidth="1.2"
            strokeDasharray="4 8"
          />

          {/* Contour Level 02 */}
          <path
            d="M 500 250 C 640 260, 740 360, 730 500 C 720 630, 620 730, 500 720 C 380 710, 280 600, 280 500 C 280 400, 360 240, 500 250 Z"
            fill="none"
            stroke="rgba(5, 150, 105, 0.22)"
            strokeWidth="1.4"
          />

          {/* Contour Level 03 (Chlorophyll Crest) */}
          <path
            d="M 500 320 C 600 330, 670 410, 660 500 C 650 590, 580 660, 500 650 C 420 640, 350 560, 350 500 C 350 440, 400 310, 500 320 Z"
            fill="none"
            stroke="rgba(0, 168, 107, 0.35)"
            strokeWidth="1.6"
            strokeDasharray="8 6"
          />

          {/* Biome Peak Node */}
          <circle cx="500" cy="500" r="40" fill="none" stroke="rgba(10, 28, 20, 0.15)" strokeWidth="1" />
          <circle cx="500" cy="500" r="4" fill="#059669" />

          {/* Topographic Elevation Coordinates */}
          <text x="515" y="495" fill="rgba(10, 28, 20, 0.4)" fontSize="10" fontFamily="monospace" letterSpacing="2">
            ELEV: +1,840M // SECTOR TAPAJOS
          </text>
        </svg>
      </div>

      {/* Clean Bottom Gradient */}
      <div
        className="absolute bottom-0 left-0 right-0 h-48 opacity-30 pointer-events-none"
        style={{
          background: 'linear-gradient(to top, rgba(244, 245, 239, 0.8) 0%, transparent 100%)',
        }}
      />
    </div>
  );
};
